// Firebase v10 compat mode for service worker
// eslint-disable-next-line no-undef
importScripts("https://www.gstatic.com/firebasejs/12.12.1/firebase-app-compat.js");
// eslint-disable-next-line no-undef
importScripts("https://www.gstatic.com/firebasejs/12.12.1/firebase-messaging-compat.js");

try {
    // eslint-disable-next-line no-undef
    firebase.initializeApp({
        apiKey: process.env.FirebaseAPIKey,
        authDomain: process.env.FirebaseAuthDomain,
        databaseURL: process.env.FirebaseDatabaseURL,
        projectId: process.env.FirebaseProjectId,
        storageBucket: process.env.FirebaseStorageBucket,
        messagingSenderId: process.env.FirebaseMessagingSenderId,
        appId: process.env.FirebaseAppId,
        measurementId: process.env.FirebaseMeasurementId
    });

    // eslint-disable-next-line no-undef
    firebase.messaging();
} catch (err) {
    console.log(err);
}
